import React, { Component } from 'react'
import PropTypes from 'prop-types'
import LaunchIcon from '@material-ui/icons/Launch'
import Button from '@material-ui/core/Button'

export default class TillManagementForm extends Component {
  static propTypes = {
    hiboutikAccount: PropTypes.string.isRequired,
    onClick: PropTypes.func
  }
  handleSubmitClick = e => {
    this.refs.form.submit()
    if (this.props.onClick) {
      this.props.onClick()
    }
  }
  render() {
    const { hiboutikAccount } = this.props
    return (
      <div>
        <Button
          variant="raised"
          color="primary"
          onClick={this.handleSubmitClick}>
          Vérifier la caisse
          <LaunchIcon style={{ marginLeft: 10 }} color="inherit" />
        </Button>
        <form
          ref="form"
          method="post"
          action={`https://${hiboutikAccount}.hiboutik.com/`}
          target="_blank">
          <input type="hidden" name="show_tab" value="caisse" />
          <input type="hidden" name="nom_button_form" value="Caisse" />
        </form>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/hiboutikForms/TillManagementForm.js